// extracted by mini-css-extract-plugin
export default {"p_content":"a0a33ca3ae"};